import * as React from 'react';
import { CurrentUserState } from '../../../../mainv2/states/CurrentUserState';
import { NotificationBar, NotificationSubTitle, NotificationTitle } from './NotificationBar';
import { routingStore } from '../../../../common/stores/routing';
import { V3Routes } from '../../../routes';
import moment from 'moment-timezone';
import { V3MembershipPlanKey } from '../../../../mainv2/types/user';
import { observer } from 'mobx-react';

type Props = {
    userState: CurrentUserState;
};

function shouldShowWithdrawalNotification(withdrawalEffectiveDate) {
    const oneMonthSince = moment().add(1, 'month');
    return withdrawalEffectiveDate.format('YYYY-MM-DD') < oneMonthSince.format('YYYY-MM-DD');
}

function getRemainingDaysTo(targetDate) {
    return moment(targetDate)
        .startOf('day')
        .diff(moment().startOf('day'), 'day');
}

@observer
export class WithdrawalNotification extends React.Component<Props> {
    render() {
        const { userState } = this.props;

        if (userState.withdrawal.isWithdrawalSet) {
            const withdrawalEffectiveDate = moment(userState.withdrawal.withdrawal.effective_at);

            if (shouldShowWithdrawalNotification(withdrawalEffectiveDate)) {
                return userState.currentUser.membership_items.map((membership_item) => {
                    switch (membership_item.membership_plan_key) {
                        case V3MembershipPlanKey.SPRING_2020:
                        case V3MembershipPlanKey.MAKUAKE_STANDARD:
                        case V3MembershipPlanKey.GOTO_2020:
                            return (
                                <NotificationBar
                                    id="makuake-standard-withdrawal-notification"
                                    type="warning"
                                    buttonLabel="継続の手続きに進む"
                                    onClick={() => routingStore.push(V3Routes.application())}
                                >
                                    <NotificationTitle>
                                        {membership_item.name}の期限が切れるまで、あと{getRemainingDaysTo(
                                            withdrawalEffectiveDate
                                        )}日です。
                                    </NotificationTitle>
                                    <NotificationSubTitle>
                                        今会員を継続すると、月額料金のみで継続ができます。
                                    </NotificationSubTitle>
                                </NotificationBar>
                            );
                            break;
                        case V3MembershipPlanKey.MAKUAKE_TRIAL:
                            return (
                                <NotificationBar
                                    id="makuake-trial-withdrawal-notification"
                                    type="warning"
                                    buttonLabel="継続の手続きに進む"
                                    onClick={() => routingStore.push(V3Routes.applicationStartDateSelect())}
                                >
                                    <NotificationTitle>
                                        お試しプランの期限が切れるまで、あと{getRemainingDaysTo(
                                            withdrawalEffectiveDate
                                        )}日です。
                                    </NotificationTitle>
                                    <NotificationSubTitle>
                                        今会員を継続すると、入会金が3万円OFFに。
                                    </NotificationSubTitle>
                                </NotificationBar>
                            );
                            break;
                    }
                });
            }
        }
        return null;
    }
}
